export const UI_ROLES = [
  { label: "Migration - UiPath", value: "migration_uipath" },
  { label: "Migration - Blue Prism", value: "migration_bp" },
  { label: "Migration - Automation Anywhere", value: "migration_aa" },
  { label: "Migration - Selenium", value: "migration_selenium" },
  { label: "AI Studio", value: "ai_studio" },
  { label: "Proposal", value: "proposal" },
  { label: "BRD Creation", value: "brd" },
  { label: "BRD to SDD", value: "brd_to_sdd" },
  { label: "WF to SDD", value: "wf_to_sdd" },
  { label: "Code Review", value: "code_review" },
  { label: "Test Cases", value: "test_case" },
  { label: "Log Analyzer", value: "log_analyzer" },
  { label: "Support Admin", value: "SUPPORT_ADMIN" },
  { label: "Support Senior", value: "SUPPORT_SENIOR" },
  { label: "Support Junior", value: "SUPPORT_JUNIOR" },
  { label: "Support Business", value: "SUPPORT_BUSINESS" },
  { label: "AE Support", value: "support_copilot" },
  { label: "Minutes of Meeting", value: "mom" },
  { label: "CSM", value: "csm" },
  { label: "Training Team", value: "training_team" },
  { label: "BA Assist", value: "ba_assist" },
  { label: "BA Assist Admin", value: "ba_assist_admin" },
  { label: "CSM Admin", value: "csm_admin" },
  { label: "CSM Super Admin", value: "csm_super_admin" },
  { label: "CSM India", value: "csm_india" },
  { label: "Email Automation", value: "email_automation" },
  { label: "Dashboard Access", value: "analytics_viewer" },
  { label: "User Admin", value: "user_admin" },
  { label: "Admin", value: "admin" },
];

// Roles offered on the public signup page: the APA Lifecycle tools, without Proposal.
const SIGNUP_ROLE_VALUES = ["brd", "brd_to_sdd", "test_case", "code_review", "log_analyzer", "support_copilot"];
export const SIGNUP_ROLES = UI_ROLES.filter((role) => SIGNUP_ROLE_VALUES.includes(role.value));

// Roles the current account may hand out. A super admin gets everything; a User Admin only gets the
// signup roles (plus any role the target user already holds, so it stays visible and isn't dropped);
// anyone else gets everything except admin / user_admin.
export function getAssignableRoles({ isSuperAdmin, isUserAdmin, heldRoles = [] }) {
  if (isSuperAdmin) return UI_ROLES;
  if (isUserAdmin) return UI_ROLES.filter((r) => SIGNUP_ROLE_VALUES.includes(r.value) || heldRoles.includes(r.value));
  return UI_ROLES.filter((r) => r.value !== "admin" && r.value !== "user_admin");
}

export const ROLE_LABELS = Object.fromEntries(UI_ROLES.map((role) => [role.value, role.label]));

export const ROLE_SELECT_MENU_PROPS = {
  PaperProps: {
    sx: {
      maxHeight: "min(420px, calc(100vh - 96px))",
      borderRadius: "14px",
      overflowY: "auto",
      "& .MuiMenu-list": {
        py: 0.5,
      },
      "& .MuiMenuItem-root": {
        minHeight: 38,
        py: 0.75,
        fontSize: 14,
      },
    },
  },
};
